import { EInvoiceSenderComplianceMessage } from "bookkeeping/detail/EInvoiceSenderComplianceMessage";
import React from "react";
import { CompanyCanReceivePeppol } from "./CompanyCanReceivePeppol";

interface Props {
  compliance: server.dto.EInvoiceInvoiceV2Compliance;
}

export const EInvoiceInvoiceV2Compliance = (props: Props) => {

  if (props.compliance.recipient == null) {
    return <EInvoiceSenderComplianceMessage compliance={props.compliance.sender} />
  }

  return <CompanyCanReceivePeppol compliance={props.compliance.recipient} />
}